import axios from '../config/axiosPrivate';

export const getUniques = async () => {
  const response = await axios.get('/communities/uniques');
  return response.data;
};
